// constants referencing to the css variables
// to avoid duplication of names

//COLORES CON NOMBRE CORRECTO SEGUN STORYBOOK
export const colors = {
    primary: {
        default: 'var(--color-primary)',
        dark: 'var(--color-primary-dark)',
        light01: 'var(--color-primary-light-01)',
        light02: 'var(--color-primary-light-02)',
        light03: 'var(--color-primary-light-03)',
    },
    secondary: {
        default: 'var(--color-secondary)',
        dark: 'var(--color-secondary-dark)',
        light: 'var(--color-secondary-light)',
    },
    error: {
        default: 'var(--color-error)',
        dark: 'var(--color-error-dark)',
        light: 'var(--color-error-light)',
    },
    success: {
        default: 'var(--color-success)',
        dark: 'var(--color-success-dark)',
        light: 'var(--color-success-light)',
    },
    info: {
        default: 'var(--color-info)',
        dark: 'var(--color-info-dark)',
        light: 'var(--color-info-light)',
    },
    warning: {
        default: 'var(--color-warning)',
        dark: 'var(--color-warning-dark)',
        light: 'var(--color-warning-light)',
    },
    black: 'var(--color-black)',
    gray: {
        gray08: 'var(--color-gray-08)',
        gray07: 'var(--color-gray-07)',
        gray06: 'var(--color-gray-06)',
        gray05: 'var(--color-gray-05)',
        gray04: 'var(--color-gray-04)',
        gray03: 'var(--color-gray-03)',
        gray02: 'var(--color-gray-02)',
    },
    white: 'var(--color-white)',
    whiteTransparent: 'var(--color-white-transparent)'
};

//Colores con nombres deprecados, NO USAR
export const COLOR_PRIMARIO = 'var(--color-primario)'
export const COLOR_SECUNDARIO = 'var(--color-secundario)'
export const COLOR_TERCIARIO = 'var(--color-terciario)'
export const COLOR_PRIMARIO_DARK = 'var(--color-primario-dark)'
export const COLOR_SECUNDARIO_DARK = 'var(--color-secundario-dark)'
export const COLOR_SECUNDARIO_DARK_X2 = 'var(--color-secundario-darkx2)'
export const COLOR_TERCIARIO_DARK = 'var(--color-terciario-dark)'
export const COLOR_TERCIARIO_DARK_X2 = 'var(--color-terciario-darkx2)'
export const COLOR_PRIMARIO_LIGHT = 'var(--color-primario-light)'
export const COLOR_PRIMARIO_LIGHT_2 = 'var(--color-primario-light-2)'
export const COLOR_SECUNDARIO_LIGHT = 'var(--color-secundario-light)'
export const COLOR_TERCIARIO_LIGHT = 'var(--color-terciario-light)'
export const COLOR_DANGER = 'var(--color-danger)'
export const COLOR_DANGER_DARK = 'var(--color-danger-dark)'
export const COLOR_DANGER_LIGHT = 'var(--color-danger-light)'
export const COLOR_SUCCESS = 'var(--color-success)'
export const COLOR_SUCCESS_DARK = 'var(--color-success-dark)'
export const COLOR_INFO = 'var(--color-info)'
export const COLOR_INFO_DARK = 'var(--color-info-dark)'
export const COLOR_WARNING = 'var(--color-warning)'

export const COLOR_TEXT_BLANCO = 'var(--color-text-blanco)'
export const COLOR_TEXT_EXTRA_LIGHT = 'var(--color-text-extra-light)'
export const COLOR_TEXT_LIGHT = 'var(--color-text-light)'
export const COLOR_TEXT_MEDIUM = 'var(--color-text-medium)'
export const COLOR_TEXT = 'var(--color-text)'
export const COLOR_TEXT_DARK = 'var(--color-text-dark)'
export const COLOR_TEXT_NEGRO = 'var(--color-text-negro)'

export const COLOR_FONDO_BLANCO = 'var(--color-fondo-blanco)'
export const COLOR_FONDO_HOVER_CLARO = 'var(--color-fondo-hover-claro)'

export const COLOR_FONDO_SELECT_ACTIVE = 'var(--color-fondo-hover-claro)'
export const COLOR_FONDO_SELECT_HOVER = 'var(--color-fondo-active-claro)'

export const COLOR_GRIS_FONDO = 'var(--color-gris-fondo)'
export const COLOR_GRIS_DISABLE_FONDO = 'var(--color-text-gris-disable)'
